import React from 'react';

interface LogoIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const LogoIcon: React.FC<LogoIconProps> = ({
  width = 24,
  height = 25,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.5021 2.99785C20.7102 2.20593 19.7701 1.57775 18.7354 1.14917C17.7008 0.720589 16.5918 0.5 15.4719 0.5C14.3519 0.5 13.243 0.720589 12.2083 1.14917C11.1737 1.57775 10.2335 2.20593 9.44163 2.99785C8.96043 3.47985 7.95793 4.60666 7.61548 5.16164C9.24394 4.15651 11.1634 3.72903 13.0645 3.94811C14.9656 4.16718 16.7376 5.02005 18.0947 6.36924C19.4519 7.71842 20.3152 9.4853 20.5454 11.3851C20.7757 13.2848 20.3595 15.2068 19.364 16.8412L19.4955 16.7096C20.0665 16.3632 21.0089 15.5515 21.5021 15.0583C22.294 14.2664 22.9222 13.3263 23.3508 12.2916C23.7794 11.257 24 10.148 24 9.02808C24 7.90816 23.7794 6.7992 23.3508 5.76453C22.9222 4.72986 22.294 3.78974 21.5021 2.99785Z"
        fill="#292F37"
      />
      <path
        d="M7.04466 17.4553C3.6939 14.1046 1.64158 7.94122 5.42301 1.42578L3.65541 3.19339C1.31481 5.53408 -7.52338e-05 8.7087 3.22857e-09 12.0189C7.52402e-05 15.329 1.31511 18.5036 3.65581 20.8442C5.9965 23.1848 9.17113 24.4997 12.4813 24.4996C15.7915 24.4995 18.966 23.1845 21.3066 20.8438L23.0742 19.0762C16.8692 22.6836 10.6946 21.1052 7.04466 17.4553Z"
        fill="#292F37"
      />
    </svg>
  );
};

export default LogoIcon;
